import { render, staticRenderFns } from "./CompanySizes.vue?vue&type=template&id=81bf0fc0&"
import script from "./CompanySizes.vue?vue&type=script&lang=js&"
export * from "./CompanySizes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports